import * as moment from 'moment-timezone'

import { Controller } from 'stimulus'

export default class TimezoneController extends Controller {
  static targets = [ 'timezone' ]

  connect() {
    this.timezoneTarget.value = moment.tz.guess()
  }
}
